import Datepicker from 'vanillajs-datepicker/Datepicker';

import { ChangeDateEvent } from '../shared/interfaces';

const parseDutchOrIsoDate = (value: string): Date | null => {
    if (!value) {
        return null;
    }

    const dutchMatch = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value.trim());
    if (dutchMatch) {
        const [, day, month, year] = dutchMatch;
        return new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0, 0);
    }

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const formatDutchDate = (date: Date): string => {
    const day = `${date.getDate()}`.padStart(2, '0');
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
};

document.addEventListener('DOMContentLoaded', (): void => {
    const $datepickers = document.querySelectorAll<HTMLInputElement>('.date-picker');

    if ($datepickers.length) {
        const datepickerInstances: Datepicker[] = [];

        const options: ConstructorParameters<typeof Datepicker>[1] = {
            autohide: true,
            format: 'dd-mm-yyyy',
            nextArrow: '<i class="fa-solid fa-angle-right"></i>',
            prevArrow: '<i class="fa-solid fa-angle-left"></i>',
            orientation: 'bottom left',
            defaultViewDate: new Date()
        };

        $datepickers.forEach(($datepicker, i) => {
            datepickerInstances[i] = new Datepicker($datepicker, options);

            if ($datepicker.hasAttribute('data-umb')) {
                const hiddenId = `${$datepicker.id}_1`;
                const $hiddenDatepicker = document.getElementById(hiddenId) as HTMLInputElement | null;
                const initialDate = parseDutchOrIsoDate($hiddenDatepicker?.value ?? $datepicker.value);

                if (initialDate) {
                    const date = new Date(initialDate.setHours(12, 0, 0, 0));
                    datepickerInstances[i].setDate(date);
                    $datepicker.value = formatDutchDate(date);
                }

                $datepicker.addEventListener('changeDate', (event: Event) => {
                    const e = event as ChangeDateEvent;
                    const date = new Date(new Date(e.detail.date).setHours(12, 0, 0, 0));
                    const hiddenInput = document.getElementById(`${e.target.id}_1`) as HTMLInputElement | null;

                    $datepicker.value = formatDutchDate(date);

                    if (hiddenInput) {
                        hiddenInput.value = date.toISOString();
                    }
                });
            }
        });
    }
});
